export default __webpack_public_path__ + "static/media/Website_Terms_of_Use.fa1a205d.pdf";